// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2012":"d3b9be43","4366":"9b292faf","5671":"c160633f","8465":"a3d08312"}[chunkId] + ".css";
};